import React from "react";
import logo from "../logo.svg";

function Changelog(props) {
  return (
    <div>
      <header className="App-header" style={{ justifyContent: "start" }}>
        <img src={logo} className="App-logo" alt="logo" />
        <p>{process.env.REACT_APP_NAME}</p>
        <h5>{process.env.REACT_APP_ENVIRONMENT}</h5>
        <h5>{process.env.REACT_APP_ORG}</h5>
        <h5>{process.env.REACT_APP_CAREPLAN}</h5>
        <h6>Build:{process.env.REACT_APP_BUILD}</h6>
        <br />
        {/* {content && content.map((item) => <p key={item.Id}>{item["@Name"]}</p>)} */}
        <br />
        <h5>Recent Changes</h5>
        <div className="h5">Recent Changes</div>
        <ul className="changelog">
          <li>Bed Appointment modal implemented</li>
          <li>Added MPI to Search Discharge Clients in Team Caseload</li>
          <li>-------------------------------------</li>
          <li>On Discharge, update Bed Appointment Service Status</li>
          <li>On Call phone numbers auto populated</li>
          <li>Set Discharge time to 11:59 PM</li>
          <li>Search for Discharged Clients</li>
          <li>Care Team bug fix with missing role</li>
          <li>-------------------------------------</li>
          <li>Added SOAR Dashboards button to Reports module</li>
          <li>Scroll To Top button added to Forms</li>
          <li>Edit Client Payor fix</li>
          <li>-------------------------------------</li>
          <li>Added Login Report</li>
        </ul>
      </header>
    </div>
  );
}

export default Changelog;
